export default "__VITE_ASSET__BHqfOlCn__"